<div class="d-block d-sm-none platnost-hesla-mobil" *ngIf="data.expiraciaHesla">
    <span i18n>Platnosť hesla končí</span>: <b class="text-danger">{{data.expiraciaHesla | date}}</b>
</div>

<div class="card d-none d-sm-block" *ngIf="data">
  <h4 class="card-header"><strong>{{data.fullName}}</strong></h4>
  <div class="card-body small">
    <div>IDO: {{data.ido}}</div>
    <br/>
    <span i18n>Posledné prihlásenie</span>
    <br>{{data.lastLoginTime}}
    <br>{{data.lastLoginIp}}
    <div *ngIf="data.today">
      <br/><span i18n>Dnes je</span>: <b>{{data.today|date}}</b>
    </div>
    <div *ngIf="data.meniny">
      <span i18n>Meniny má</span>: <b>{{data.meniny}}</b>
    </div>
    <div *ngIf="data.expiraciaHesla">
      <span i18n>Platnosť hesla končí</span>: <b class="text-danger">{{data.expiraciaHesla | date}}</b>
    </div>
  </div>
</div>
